import { PayPasswordModalProps } from "./types"
import React, { useRef, useState, useEffect } from "react"
import styled from '~/ui/styled'
import { Text as TextCore } from "~widgets/text"
import { Platform, Keyboard, TextInput, Modal, Button, View } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import { useStores } from "~models"

// import { MaskLoading } from "~components/mask-loading"
// import useNavigation from "~hooks/useNavigation"
import { useKeyboard } from "../../hooks/use-keyboard"
import { globalSpinner } from "~utils"
import { prompt } from "~utils/prompt"

const ModalBg = styled.View`
  background-color: rgba(0, 0, 0, 0.2);
  flex: 1;
  justify-content: flex-end;
  align-items: center;
`
const TextBtn = styled.View`
  position: relative;
  justify-content: center;
  align-items: center;
  flex: 1;
  margin-top: 10px;
  padding: 3px;
`
const CoverView = styled.View`
  position: absolute;
  left: 3px;
  top: 3px;
  width: 100%;
  height: 100%;
  background-color: transparent;
`

const ContentArea = styled.View`
  justify-content: center;
  align-items: center;
  background-color: white;
  /* border-color: rgb(200, 200, 200);
  border-width: 1px;
  border-radius: 10px; */
`

const ContentBlock = styled.TouchableOpacity`
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
`
const TextFiledBlock = styled.View`
  align-items: center;
  padding-left: 15px;
  padding-right: 15px;
`
const ModalTitle = styled.Text`
  color: black;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  font-weight: bold;
  padding: 20px;
`
const Text = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: rgb(28, 156, 234);
  padding: ${({ theme }) => theme.space.sm} 0;
`

const PayPasswordModal: React.FC<PayPasswordModalProps> = ({ visible, setVisible, callBack }) => {
  const { apiStore, authStore } = useStores()
  const [passwrodList, setPasswrodList] = useState(["", "", "", "", "", ""])
  // const [isLoading, setIsLoading] = useState(false)
  // const [isError, setIsError] = useState(false)
  const ref_input0 = useRef(null)
  const ref_input1 = useRef(null)
  const ref_input2 = useRef(null)
  const ref_input3 = useRef(null)
  const ref_input4 = useRef(null)
  const ref_input5 = useRef(null)

  const { keyboardHeight } = useKeyboard()
  // const navigation = useNavigation()

  useEffect(() => {
    if (Platform.OS === "android") {
      focusInput()
    } else {
      if (visible) {
        focusInput()
      }
    }
  }, [visible])
  const focusInput = () => {
    let timer = null
    if (timer) clearTimeout(timer)
    if (ref_input0.current) {
      timer = setTimeout(() => {
        ref_input0.current.focus()
      }, 300)
    }
  }

  useEffect(() => {
    const keyboardWillHide = Keyboard?.addListener("keyboardDidHide", () => {
      clearArray()
      setVisible(false)
    })
    return () => {
      keyboardWillHide?.remove()
    }
  }, [])

  const checkPassword = async (array) => {
    const token = authStore.getToken
    const val = array.toString()
    const substring = ","
    const replacement = ""

    const newSubject = val.replace(new RegExp(substring, "g"), replacement)

    // setIsLoading(true)
    const payload = {
      token,
      pay_pwd: newSubject,
    }

    try {
      const res = await apiStore.payCheck(payload)
      if (res.code === 200) {
        callBack(true)
      }
    } catch (error) {
      clearArray()
      // setIsError(true)
      // setIsError(false)
      setVisible(false)
      prompt({
        title: "",
        message: "密码错误，请重新输入！",
        onSuccess: () => {
          setVisible(true)
        },
        successText: "重新输入",
        cancelText: "取消",
      })
    } finally {
      clearArray()
      // setIsLoading(false)
      globalSpinner.close()
    }
  }
  // const goToResetPws = () => {
  //   callBack(false)

  //   navigation.push("SettingPayNumber", { pay_pwd: true })
  // }
  const hangleTextChange = async (text, i) => {
    // if (isError) {
    //   setIsError(false)
    // }

    const newPasswrodList = [...passwrodList]
    newPasswrodList[i] = text
    if (i >= 5) {
      setPasswrodList(newPasswrodList)
      await setVisible(false)
      await globalSpinner.show("验证中")
      await checkPassword(newPasswrodList)
    } else {
      setPasswrodList(newPasswrodList)
    }
    if (text === "" && i >= 0) {
      i = i - 2
    }
    switch (i) {
      case 0:
        ref_input1?.current?.focus()
        break
      case 1:
        ref_input2?.current?.focus()
        break
      case 2:
        ref_input3?.current?.focus()
        break
      case 3:
        ref_input4?.current?.focus()
        break
      case 4:
        ref_input5?.current?.focus()
        break
      case 5:
        ref_input0?.current?.focus()
        break

      default:
        ref_input0?.current?.focus()
        break
    }
  }

  const switchFn = (i) => {
    switch (i) {
      case 0:
        ref_input0?.current?.focus()
        break
      case 1:
        ref_input0?.current?.focus()
        break
      case 2:
        ref_input1?.current?.focus()
        break
      case 3:
        ref_input2?.current?.focus()
        break
      case 4:
        ref_input3?.current?.focus()
        break
      case 5:
        ref_input4?.current?.focus()
        break
      default:
        ref_input0?.current?.focus()
        break
    }
  }

  const hangleKeyPress = (e, i) => {
    // const keyCode = e.nativeEvent.keyCode; // 安卓
    const key = e?.nativeEvent?.key // 适用于iOS
    if (key === "Backspace" && !passwrodList[i]) {
      const newPasswrodList = [...passwrodList]
      newPasswrodList[i - 1] = ""
      switchFn(i)
      setPasswrodList(newPasswrodList)
    }
  }

  const clearArray = () => {
    const newPasswrodList = [...passwrodList]
    newPasswrodList.forEach((element, index) => {
      newPasswrodList[index] = ""
    })
    setPasswrodList(newPasswrodList)
  }
  return (
    <Modal
      visible={visible}
      transparent={true}
      // animationType="slide"
      onRequestClose={() => {
        setVisible(false)
      }}
    >
      {/* <Modal animationType="fade" transparent={true} visible={isLoading}>
        <MaskLoading text="验证中" />
      </Modal> */}
      <ModalBg
        style={{ paddingBottom: Platform.OS === "android" ? 0 : keyboardHeight }}
        // onClick={() => setVisible(false)}
      >
        <ContentArea>
          <ContentBlock
            onClick={() => {
              clearArray()
              // setIsError(false)
              setVisible(false)
            }}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <Text style={{ color: "rgb(200,200,200)" }}>关闭</Text>
          </ContentBlock>

          <TextFiledBlock
            style={{
              alignItems: "center",
            }}
          >
            <ModalTitle>请输入支付密码</ModalTitle>
          </TextFiledBlock>

          <TextFiledBlock
            style={{
              flexDirection: "row",
              display: "flex",
              borderTopColor: "#e6e6e6",
              borderTopWidth: 1,
              height: 70,
            }}
          >
            <TextBtn>
              <TextInput
                caretHidden={true}
                maxLength={1}
                keyboardType="numeric"
                placeholder={""}
                ref={ref_input0}
                value={passwrodList[0]}
                secureTextEntry={true}
                onChangeText={(text) => {
                  hangleTextChange(text, 0)
                }}
                style={{
                  borderWidth: 1,
                  fontSize: 25,
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  textAlign: "center",
                }}
              />
              <CoverView />
            </TextBtn>
            <TextBtn>
              <TextInput
                caretHidden={true}
                maxLength={1}
                keyboardType="numeric"
                placeholder={""}
                ref={ref_input1}
                value={passwrodList[1]}
                secureTextEntry={true}
                onChangeText={(text) => {
                  hangleTextChange(text, 1)
                }}
                onKeyPress={(e) => hangleKeyPress(e, 1)}
                style={{
                  borderWidth: 1,
                  fontSize: 25,
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  textAlign: "center",
                }}
              />
              <CoverView />
            </TextBtn>
            <TextBtn>
              <TextInput
                caretHidden={true}
                maxLength={1}
                keyboardType="numeric"
                placeholder={""}
                ref={ref_input2}
                value={passwrodList[2]}
                secureTextEntry={true}
                onChangeText={(text) => {
                  hangleTextChange(text, 2)
                }}
                onKeyPress={(e) => hangleKeyPress(e, 2)}
                style={{
                  borderWidth: 1,
                  fontSize: 25,
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  textAlign: "center",
                }}
              />
              <CoverView />
            </TextBtn>
            <TextBtn>
              <TextInput
                caretHidden={true}
                maxLength={1}
                keyboardType="numeric"
                placeholder={""}
                ref={ref_input3}
                value={passwrodList[3]}
                secureTextEntry={true}
                onChangeText={(text) => {
                  hangleTextChange(text, 3)
                }}
                onKeyPress={(e) => hangleKeyPress(e, 3)}
                style={{
                  borderWidth: 1,
                  fontSize: 25,
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  textAlign: "center",
                }}
              />
              <CoverView />
            </TextBtn>
            <TextBtn>
              <TextInput
                caretHidden={true}
                maxLength={1}
                keyboardType="numeric"
                placeholder={""}
                ref={ref_input4}
                value={passwrodList[4]}
                secureTextEntry={true}
                onChangeText={(text) => {
                  hangleTextChange(text, 4)
                }}
                onKeyPress={(e) => hangleKeyPress(e, 4)}
                style={{
                  borderWidth: 1,
                  fontSize: 25,
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  textAlign: "center",
                }}
              />
              <CoverView />
            </TextBtn>
            <TextBtn>
              <TextInput
                caretHidden={true}
                maxLength={1}
                keyboardType="numeric"
                placeholder={""}
                ref={ref_input5}
                value={passwrodList[5]}
                secureTextEntry={true}
                onChangeText={(text) => {
                  hangleTextChange(text, 5)
                }}
                onKeyPress={(e) => hangleKeyPress(e, 5)}
                style={{
                  borderWidth: 1,
                  fontSize: 25,
                  width: "100%",
                  height: "100%",
                  borderRadius: 15,
                  textAlign: "center",
                }}
              />
              <CoverView />
            </TextBtn>
          </TextFiledBlock>
          <View style={{ display: "none" }}>
            <Button title="" onClick={focusInput} />
          </View>
          <TextFiledBlock style={{ marginBottom: 20 }}></TextFiledBlock>
        </ContentArea>
      </ModalBg>
    </Modal>
  )
}

export default observer(PayPasswordModal)
